const isDevelopment = process.env.NODE_ENV === "development";

export const logError = (...args: unknown[]) => {
    if (isDevelopment) {
        console.error(...args);
    }
};

export const logDebug = (...args: unknown[]) => {
    if (isDevelopment) {
        console.log(...args);
    }
};
